import { Section } from './section'
import { HighlightCallout } from './highlight-callout'
import { BodyText, BulletList, Subheading, Subsection } from './styles'

export const Identity = () => {
  return (
    <Section title="Identity">
      <HighlightCallout
        title="Your passport is the quickest way."
        description="A photo or scan of the page with your photo on it. Expired UK passports are fine."
      />
      <BodyText>You'll also take a quick selfie so we can match it to your ID.</BodyText>
      <Subsection>
        <Subheading>No passport? You'll need one of these instead:</Subheading>
        <BulletList>
          <li>Driving licence, photos of both sides</li>
          <li>UK birth certificate</li>
          <li>Identity card — also called a biometric residence card or permit</li>
          <li>UK immigration status document</li>
        </BulletList>
      </Subsection>
    </Section>
  )
}
